/**
 *
 * Names of the items the addins access in the local storage
 */

enum LocalStorageNames {
    addinSession = "session", // Session created by this page outside of geotab
    geotabSessionPrefix = "sTokens_",
    sessionKeyPrefix= "geotabClientCredentials_",
    activeSessionKey= "activeSessionId",
    userUiSettingsPrefix = "userUiSettings_",
    faultOverviewFromDate = "ffov_fromDate",
    faultOverviewToDate = "ffov_toDate",
    fuelCellFromDate = "fuelCell_fromDate",
    fuelCellToDate = "fuelCell_toDate",
    logbookCheckFromDate = "logbookCheck_fromDate",
    logbookCheckToDate = "logbookCheck_toDate",
    logbookCheckColumnVisibility = "logbookCheck_columnVisibility",
    energyReportFromDate = "energyReport_fromDate",
    energyReportToDate = "energyReport_toDate"
}
export default LocalStorageNames
